import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Request from "../../../../api/Requests";
import { Puff, Oval } from "react-loading-icons";
import NavBar from "../../../../components/NavBar";
import "./WalletBuyCredits.css"; // Reuse existing styles

const WalletTransactionScreen = () => {
    const [isLoading, setIsLoading] = useState(true);
    let params = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({
        transaction: null,
    })

    const handlerGetTransaction = async () => {
        // Don't set full page loading on refresh to avoid flickering
        if (!state.transaction) {
            setIsLoading(true);
        }
        let response = await Request('venues/get-wallet-transaction-info', 'GET', { id: params.transaction_id }, true);
        if (response && response.status) {
            setState({ transaction: response.data.transaction });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        handlerGetTransaction();
    }, []);

    const WaitingPayment = () => {
        useEffect(() => {
            let timer;
            // Poll every 2 seconds
            timer = setTimeout(() => {
                handlerGetTransaction();
            }, 2000);

            return () => {
                clearTimeout(timer);
            };
        }, [state.transaction]);

        return (
            <div className="glass-panel text-center py-5 animate-fade-in">
                <div className="mb-4">
                    <div className="position-relative d-inline-block">

                        <img
                            src="/img/payments/mbway.png"
                            alt="MBWAY"
                            style={{ height: '60px', position: 'relative', zIndex: 2 }}
                        />
                    </div>
                </div>
                <h3 className="text-white mb-3">Aguardar pagamento...</h3>
                <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                    Por favor, abra a sua aplicação MBWAY e confirme o pagamento.
                </p>
                <div className="d-flex justify-content-center align-items-center gap-2 text-success bg-success bg-opacity-10 d-inline-flex px-4 py-2 rounded-pill border border-success border-opacity-25">
                    <Oval stroke="#11cb5f" height="1.5em" width="1.5em" />
                    <span className="fw-bold">A aguardar confirmação</span>
                </div>
            </div>
        )
    }

    const PaymentCompleted = () => {
        return (
            <div className="glass-panel text-center py-5 animate-fade-in">
                <div className="mb-4">
                    <div className="success-icon-circle">
                        <i className="fa-solid fa-check text-white fs-1"></i>
                    </div>
                </div>
                <h3 className="text-white mb-3">Pagamento Efetuado!</h3>
                <p className="text-muted mb-4">
                    Os créditos foram adicionados à sua carteira com sucesso.
                </p>
                <button
                    className="action-button"
                    style={{ maxWidth: '300px', margin: '0 auto' }}
                    onClick={() => navigate(`/my/nightspots/${params.id}/wallet/`)}
                >
                    Visualizar Carteira <i className="fas fa-wallet ms-2"></i>
                </button>
            </div>
        )
    }

    const PaymentCanceled = () => {
        return (
            <div className="glass-panel text-center py-5 animate-fade-in">
                <div className="mb-4">
                    <div className="error-icon-circle">
                        <i className="fa-solid fa-times text-white fs-1"></i>
                    </div>
                </div>
                <h3 className="text-white mb-3">Pagamento Cancelado</h3>
                <p className="text-muted mb-4">
                    O pagamento foi cancelado ou expirou. Por favor, tente novamente.
                </p>
                <button
                    className="action-button"
                    style={{ maxWidth: '300px', margin: '0 auto', background: 'linear-gradient(90deg, #df1b41, #c9183b)', boxShadow: '0 4px 15px rgba(223, 27, 65, 0.3)' }}
                    onClick={() => navigate(`/my/nightspots/${params.id}/wallet/buy-credits`)}
                >
                    Tentar Novamente <i className="fas fa-redo ms-2"></i>
                </button>
            </div>
        )
    }


    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                    minHeight: "400px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#11cb5f" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                        marginTop: "1rem",
                        color: "#fff"
                    }}
                >
                    A carregar transação...
                </div>
            </div>
        );
    };

    return (
        <div>
            <NavBar>
                <div className="wallet-buy-credits-container">
                    {isLoading ? (
                        <InsideLoading />
                    ) : (
                        <>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/my/dashboard" className="text-muted text-decoration-none">
                                                    <i className="fa-solid fa-home"></i>
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to="/my/nightspots/" className="text-muted text-decoration-none">Nightspots</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/my/nightspots/${params.id}/wallet`} className="text-muted text-decoration-none">Wallet</Link>
                                            </li>
                                            <li className="breadcrumb-item active text-white" aria-current="page">
                                                Estado da Transação
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-xl-6">
                                    {
                                        state.transaction && state.transaction.payment_status === 'PENDING' ? (
                                            <WaitingPayment />
                                        ) : state.transaction && state.transaction.payment_status === 'COMPLETED' ? (
                                            <PaymentCompleted />
                                        ) : state.transaction && state.transaction.payment_status === 'CANCELED' ? (
                                            <PaymentCanceled />
                                        ) : null
                                    }
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </NavBar >
        </div >
    );
};

export default WalletTransactionScreen;
